// WorkspaceButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Utilities
import { PhotoShape } from 'utilities/Enums';

// CSS
import './WorkspaceButton.css';

// Components
import WorkspaceCover from 'components/workspacecover/WorkspaceCover';

/**
 * WorkspaceButton
 * 
 * Renders the toggle component for the sidebar switcher.
 * 
 * @param {function} onClick - Click handler for the toggle.
 *  
 * @returns {ReactNode} - WorkspaceButton.
 */
const WorkspaceButton = React.memo(({ onClick, workspace, isActive = false }) => {

    // ----- CONTEXT ----- //

    // Theme Context
    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover State
    const [hovered, setHovered] = useState(false);

    // ---- RENDER ----- //

    return (
        <>
            <div className="workspace-button-container"
                style={{
                    backgroundColor: hovered ? theme.buttonHoverBackgroundColor : 'transparent',
                }}
                onClick={onClick}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}>

                {/* PROFILE PHOTO */}
                <div className="workspace-button-profile-photo-wrapper">

                    <WorkspaceCover
                        workspace={workspace}
                        borderWidth={0}
                        borderRadius={4}
                        size={20}
                        shape={PhotoShape.SQUARE}
                    />

                </div>

                {/* TITLE */}
                <div className="workspace-button-title-wrapper">

                    {/* TEXT */}
                    <div className="workspace-button-title-text"
                        style={{
                            color: hovered ? theme.buttonHoverLabelColor : theme.foreground,
                }}>
                        {workspace?.title || 'Workspace'}
                    </div>

                </div>

                {/* CHECK */}
                {isActive && (
                    <div className="workspace-button-title-check"
                        style={{
                            color: hovered ? theme.buttonHoverLabelColor : theme.foreground,
                        }}>
                        ✓
                    </div>
                )}

            </div>

        </>
    );

});

// Dev Tools
WorkspaceButton.displayName = 'WorkspaceButton';

export default WorkspaceButton;

